import React, { useState, useEffect } from 'react';
import PubSub from "services/PubSub/";
import { actionsType } from 'config/constants';
import ListService from "services/AccountLists/";
import Modal from 'components/Modal';
import style from './style.scss'; //NOSONAR

let actions = [];
const initialSettings = {
    setting: () => {},
};

const CreateNewListHooks = () => {
    let name = '';

    const [title, setTitle] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [settings, setSettings] = useState(initialSettings);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.CREATE_NEW_LIST_OPEN, openModalNewList));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const openModalNewList = (payload) => {
        if(payload.value){
            setTitle(payload.value.title);
            setSettings(payload.value.setting);
            setDisabled(true);
        }
    }

    const _closeModalNewList = () => {
        PubSub.dispatch('create_new_list_close');
    }

    const handleChange = (event) => {
        name = event.target.value;
    
        if (name.trim().length >= 3) {
            setDisabled(false);
        } else if(name.trim().length <= 2) {
            setDisabled(true);
        }
    }

    const _createNewList = () => {
        ListService.createEmptyList(name).then(() =>{
            PubSub.dispatch('list_update');
            if(title){
                settings.callback();
            }
        });
        _closeModalNewList();
    }

    const submitListName = () => {
        _createNewList();
    }

    return (
        <Modal customClass="modal-new-list-container" actionOpen={actionsType.MODAL.CREATE_NEW_LIST_OPEN} actionClose={actionsType.MODAL.CREATE_NEW_LIST_CLOSE}>
            <div className={"new-modal-container"}>
                <div className={'new-modal-scroll'}>
                    <div className="modal-new-list-header">
                        <span className={'new-modal-title'}>{title ? title : 'Crea una nueva lista'}</span>
                    </div>

                    <div className="modal-new-list-body">
                        <div className="modal-new-list-icn">
                            <span className="icn annotator" />
                        </div>
                        <input className="modal-new-list-input" placeholder="Nombre de nueva lista" maxLength="50" onChange={handleChange}/>
                    </div>
                </div>

                <div className={"modal-actions"}>
                    <button className={"primary-btn modal-new-list-create-btn " + (disabled ? ' disabled-btn ' : '')} onClick={submitListName}>Crear</button>
                </div>
            </div>
        </Modal>
    )
}

export default CreateNewListHooks;
